import { Link } from 'react-router-dom';
import {
  ACTIVITY_RENDERER_KEY,
  CARD_SCHEMA_V1,
  cardFallbackText,
  cardSchemaVersion,
  formatActivityTimeRange,
  isSupportedCardSchema,
  normalizeActivityBusinessCard,
} from './travelCardModel';

const UNSUPPORTED = '此卡片目前無法顯示';

export default function ActivityCardMessage({ message }) {
  const card = normalizeActivityBusinessCard(message?.businessCard);
  if (!card || card.rendererKey !== ACTIVITY_RENDERER_KEY) {
    return <p>{cardFallbackText(message, UNSUPPORTED)}</p>;
  }
  if (!isSupportedCardSchema(card)) {
    return (
      <p>
        {cardFallbackText(message, UNSUPPORTED)}
        <span className="visually-hidden"> schema {String(cardSchemaVersion(card))}</span>
      </p>
    );
  }
  if (!card.title && !card.activityId) {
    return <p>{cardFallbackText(message, UNSUPPORTED)}</p>;
  }

  const timeRange = formatActivityTimeRange(card.plannedStartTime, card.plannedEndTime);

  return (
    <article className="travel-msg-card" aria-label="行程活動">
      <p className="travel-msg-card__kicker">行程活動</p>
      <h2 className="travel-msg-card__title">{card.title || cardFallbackText(message, '未命名活動')}</h2>
      {card.activityTypeLabel ? <p>類型：{card.activityTypeLabel}</p> : null}
      {timeRange ? <p>時間：{timeRange}</p> : null}
      {card.locationLabel ? <p>地點：{card.locationLabel}</p> : null}
      {card.statusLabel ? (
        <p className="travel-msg-card__status">
          狀態：{card.statusLabel}
        </p>
      ) : null}
      {card.webRoute ? (
        <Link className="travel-msg-card__cta" to={card.webRoute}>
          查看行程
        </Link>
      ) : null}
      <span className="visually-hidden">schema {CARD_SCHEMA_V1}</span>
    </article>
  );
}
